import api from '../../../App/socket';

export const changeLeadOMConfig = (_id, config) => (
    api.send({
        api: 'db',
        model: 'Leadomatic_configuration',
        action: 'Update',
        options: {
            update: config,
            where: { _id },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_update/requests/change_leadom_config_request.js